import * as Yup from 'yup';

import type { ICustomerLeadProductFrequencyTabFormValues } from 'src/components/customers/CustomerLeadTypes';
import type { CustomerLeadPurchaseFrequency } from 'src/types/customers/CustomerLeadPurchaseFrequency';
import type { ICustomerLeadProduct } from 'src/types/customers/ICustomerLeadProduct';

export const customerLeadFrequencyTabValidationSchema = Yup.object<ICustomerLeadProductFrequencyTabFormValues>().shape({
  purchaseFrequency: Yup.mixed<CustomerLeadPurchaseFrequency>().nullable().default(null),
  purchaseFrequencyQty: Yup.number().nullable().default(null),
  contractPricing: Yup.boolean().nullable().default(null),
  additionalInfo: Yup.string().nullable().default(null),
});

export function toCustomerLeadFrequencyTabInitialValues(
  customerLeadProduct: ICustomerLeadProduct
): ICustomerLeadProductFrequencyTabFormValues {
  return {
    purchaseFrequency: customerLeadProduct.purchaseFrequency,
    purchaseFrequencyQty: customerLeadProduct.purchaseFrequencyQty,
    contractPricing: customerLeadProduct.contractPricing,
    additionalInfo: customerLeadProduct.additionalInfo,
  };
}
